export default __webpack_public_path__ + "static/media/10.7d7e40d4.png";